import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface ISendAsGift_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISendAsGift_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  CGC_GiftedCardGetById: any[];
  CGC_GiftedCardGetById_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  CGC_GiftedCardSave: number;
  CGC_GiftedCardSave_dummy: number;
  isComp829350Visible: "visible" | "hidden";
  isComp811555Enabled: "enabled" | "disabled";
}

export class SendAsGift_ScreenBase extends React.PureComponent<ISendAsGift_ScreenProps, any> {
  sendasgift_101234_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "17674926-0bc7-4f1a-91e6-cf803751ca13",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "b8c6072c-0ae7-4bca-8046-a9bc8f662491",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 523642, PropertyName: "value", Value: "Hediye Gönder" },
        { Id: 64714, PropertyName: "value", Value: "Hediye Gönderim Bilgileri" },
        { Id: 454740, PropertyName: "value", Value: "Gönderici Adı" },
        { Id: 214686, PropertyName: "placeholder", Value: "Gönderici adını giriniz.." },
        { Id: 285776, PropertyName: "value", Value: "Alıcı Adı" },
        { Id: 564861, PropertyName: "placeholder", Value: "Alıcı adını giriniz.." },
        { Id: 342691, PropertyName: "value", Value: "Alıcı Telefonu" },
        { Id: 770970, PropertyName: "placeholder", Value: "(5__) ___ __ __" },
        { Id: 44851, PropertyName: "value", Value: "Gösterilecek Mesaj" },
        { Id: 933556, PropertyName: "placeholder", Value: "Mesaj giriniz.." },
        { Id: 2815, PropertyName: "value", Value: "Gönderim Tarihi ve Saati" },
        { Id: 101234, PropertyName: "placeholder", Value: "Gönderim Tarihi ve Saati.." },
        { Id: 829350, PropertyName: "label", Value: "Hediye Gönder" }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.sendasgift_101234_value_kuikaDatetimeRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      CGC_GiftedCardGetById: [],
      SetValueOf: "",
      CGC_GiftedCardSave: 0,
      isComp829350Visible: "hidden",
      isComp811555Enabled: "disabled"
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("sendasgift", "");
      return;
    }

    if (true) {
      await this.SendAsGiftPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("sendasgift", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("sendasgift", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SendAsGiftPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form.setFieldsValue({
      sendasgift_214686_value: this.state.CGC_GiftedCardGetById?.at?.(0)?.senderName ?? undefined,
      sendasgift_564861_value: this.state.CGC_GiftedCardGetById?.at?.(0)?.receiverName ?? undefined,
      sendasgift_770970_value: this.state.CGC_GiftedCardGetById?.at?.(0)?.receiverPhone ?? undefined,
      sendasgift_933556_value: this.state.CGC_GiftedCardGetById?.at?.(0)?.messageText ?? undefined,
      sendasgift_101234_value: this.state.CGC_GiftedCardGetById?.at?.(0)?.smsSendDate ?? undefined
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  SendAsGiftPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(this.props.screenInputs.Id ?? this.props.screenInputs.id, "Guid")
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "SendAsGift/SendAsGiftPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CGC_GiftedCardGetById = result?.data.cgC_GiftedCardGetById;
    formVars.sendasgift_214686_value = ReactSystemFunctions.toString(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].senderName
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].senderName
        : null
    );
    formVars.sendasgift_564861_value = ReactSystemFunctions.toString(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].receiverName
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].receiverName
        : null
    );
    formVars.sendasgift_770970_value = ReactSystemFunctions.toString(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].receiverPhone
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].receiverPhone
        : null
    );
    formVars.sendasgift_933556_value = ReactSystemFunctions.toString(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].messageText
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].messageText
        : null
    );
    formVars.sendasgift_101234_value = ReactSystemFunctions.value(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].smsSendDate
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].smsSendDate
        : null
    );
    formVars.sendasgift_101234_disablebeforedate = moment().format("YYYY-MM-DDTHH:mm:ss");
    stateVars.isComp829350Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_GiftedCardGetById?.length > 0
            ? stateVars.CGC_GiftedCardGetById[0].id
            : this.state.CGC_GiftedCardGetById?.length > 0
            ? this.state.CGC_GiftedCardGetById[0].id
            : null
        ),
        null
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp811555Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_GiftedCardGetById?.length > 0
            ? stateVars.CGC_GiftedCardGetById[0].id
            : this.state.CGC_GiftedCardGetById?.length > 0
            ? this.state.CGC_GiftedCardGetById[0].id
            : null
        ),
        null
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SendAsGiftPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SendAsGiftPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_GiftedCardGetById?.length > 0
            ? stateVars.CGC_GiftedCardGetById[0].smsSendDate
            : this.state.CGC_GiftedCardGetById?.length > 0
            ? this.state.CGC_GiftedCardGetById[0].smsSendDate
            : null
        ),
        null
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        "sendasgift_101234_value",
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        null
      );

      this.props.form.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SendAsGiftPageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SendAsGiftPageInit2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SendAsGiftPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.isComp811555Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_GiftedCardGetById?.length > 0
            ? stateVars.CGC_GiftedCardGetById[0].id
            : this.state.CGC_GiftedCardGetById?.length > 0
            ? this.state.CGC_GiftedCardGetById[0].id
            : null
        ),
        null
      ) === true
        ? "enabled"
        : "disabled";
    formVars.sendasgift_214686_value = ReactSystemFunctions.toString(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].senderName
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].senderName
        : null
    );

    formVars.sendasgift_564861_value = ReactSystemFunctions.toString(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].receiverName
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].receiverName
        : null
    );

    formVars.sendasgift_770970_value = ReactSystemFunctions.toString(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].receiverPhone
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].receiverPhone
        : null
    );

    formVars.sendasgift_933556_value = ReactSystemFunctions.toString(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].messageText
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].messageText
        : null
    );

    formVars.sendasgift_101234_value = ReactSystemFunctions.value(
      this,
      stateVars.CGC_GiftedCardGetById?.length > 0
        ? stateVars.CGC_GiftedCardGetById[0].smsSendDate
        : this.state.CGC_GiftedCardGetById?.length > 0
        ? this.state.CGC_GiftedCardGetById[0].smsSendDate
        : null
    );

    stateVars.isComp829350Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_GiftedCardGetById?.length > 0
            ? stateVars.CGC_GiftedCardGetById[0].id
            : this.state.CGC_GiftedCardGetById?.length > 0
            ? this.state.CGC_GiftedCardGetById[0].id
            : null
        ),
        null
      ) === true
        ? "visible"
        : "hidden";

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SendAsGiftComponent_308349_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SendAsGiftComponent_829350_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "sendasgift_214686_value", "value", "", "", "")
        ),
        null
      ),
      message: "*",
      formName: "sendasgift_214686_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "sendasgift_564861_value", "value", "", "", "")
        ),
        null
      ),
      message: "*",
      formName: "sendasgift_564861_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isEqualLength(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "sendasgift_770970_value", "value", "", "", "")
        ),
        "10"
      ),
      message: "*",
      formName: "sendasgift_770970_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "sendasgift_101234_value", "value", "", "", "")
        ),
        null
      ),
      message: "*",
      formName: "sendasgift_101234_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid"),
      CusCardNumber_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CusCardNumber ?? this.props.screenInputs.cuscardnumber,
        "string"
      ),
      GiftCardCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Code ?? this.props.screenInputs.code,
        "number"
      ),
      GiftCardValidThrough_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ValidThroughText ?? this.props.screenInputs.validthroughtext,
        "string"
      ),
      SenderName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "sendasgift_214686_value", "value", "", "", "")
        ),
        "string"
      ),
      ReceiverName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "sendasgift_564861_value", "value", "", "", "")
        ),
        "string"
      ),
      ReceiverPhone_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "sendasgift_770970_value", "value", "", "", "")
        ),
        "string"
      ),
      MessageText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "sendasgift_933556_value", "value", "", "", "")
        ),
        "string"
      ),
      SMSSendDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "sendasgift_101234_value", "value", "", "", "")
        ),
        "Date"
      ),
      ValidThrough_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ValidThru ?? this.props.screenInputs.validthru,
        "Date"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "SendAsGift/SendAsGiftComponent_829350_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CGC_GiftedCardSave = result?.data.cgC_GiftedCardSave;
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SendAsGiftComponent_829350_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SendAsGiftComponent_829350_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId) {
    let isErrorOccurred = false;
  }
}
